<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>                               
                                  <e-column field='phone_plat_from' headerText='手機型號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>
                                  <e-column field='cpu_abi' headerText='CPU' width='180' ></e-column>         
                                  <e-column field='iso_value' headerText='ISO' width='220' ></e-column>                        
                                  <e-column field='is_auto_focus_m' headerText='自動對焦' width='220'></e-column>                             
                                  <e-column field='max_sharpness' headerText='最大感光度' width='180'></e-column>
                                  <e-column field='min_sharpness' headerText='最小感光度' width='180'></e-column>
                                  <e-column field='support_sharpness' headerText='支援感光度' width='180'></e-column>
                                  <e-column field='max_zoom' headerText='最大焦距' width='180'></e-column>
                                  <e-column field='support_zoom' headerText='支援焦距' width='180'></e-column>
                                  <e-column field='whitebalance_value' headerText='白平衡' width='180'></e-column>                                  
                                  <e-column field='picture_size' headerText='圖片大小' width='180'></e-column>
                                  <e-column field='preview_size' headerText='檢視大小' width='180'></e-column>                     
                                  <e-column field='sense_descript' headerText='敘述' width='180'></e-column>
                                  <e-column field='camera_descript' headerText='相機敘述' width='180'></e-column> 
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>
            <div class="dialog">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='"修改手機裝置設定"' :buttons='e_buttons' 
                        width='500px'>
                        <div formGroup="orderForm">                       
                            <div class="form-row">                          
                                <div class="form-group col-md-6">
                                  <span class="about-title-verify">手機型號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_phone_plat_from" :enabled="false" aria-required="true"></ejs-textbox>                                    
                                </div>  
                                <div class="form-group col-md-6">   
                                  <span class="about-title-verify">CPU</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_cpu_abi" :enabled="false"  aria-required="true"></ejs-textbox>                       
                                </div>  
                                <div class="form-group col-md-6">
                                  <span class="about-title-verify">ISO</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_iso_value" :enabled="false" aria-required="true"></ejs-textbox>    
                                </div>     
                                <div class="form-group col-md-6">
                                  <span class="about-title">自動對焦</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_is_auto_focus" :enabled="false" aria-required="true"></ejs-textbox>    
                                </div>    
                                <div class="form-group col-md-6">
                                  <span class="about-title">最大感光度</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_max_sharpness" aria-required="true"></ejs-textbox>    
                                </div>                             
                                <div class="form-group col-md-6">
                                  <span class="about-title">最小感光度</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_min_sharpness" aria-required="true"></ejs-textbox>    
                                </div> 
                                <div class="form-group col-md-6">
                                  <span class="about-title">支援感光度</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_support_sharpness"  aria-required="true"></ejs-textbox>    
                                </div> 
                                <div class="form-group col-md-6">
                                  <span class="about-title">最大焦距</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_max_zoom"  aria-required="true"></ejs-textbox>    
                                </div> 
                                <div class="form-group col-md-6">
                                  <span class="about-title">支援焦距</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_support_zoom" :enabled="false"  aria-required="true"></ejs-textbox>    
                                </div> 
                                <div class="form-group col-md-6">
                                  <span class="about-title">白平衡</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_whitebalance_value"  aria-required="true"></ejs-textbox>    
                                </div>
                                <div class="form-group col-md-6">
                                  <span class="about-title">圖片大小</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_picture_size" :enabled="false"  aria-required="true"></ejs-textbox>    
                                </div>                               
                                <div class="form-group col-md-6">
                                  <span class="about-title">相機敘述</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_camera_descript"  aria-required="true"></ejs-textbox>    
                                </div>
                                 <div class="form-group col-md-12">
                                  <span class="about-title">敘述</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_preview_size" aria-required="true"></ejs-textbox>    
                                </div>
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script lang="ts">

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";


setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
        'Print': '列印',
        'Search': '搜尋'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(Loading);

let DialogObj   = undefined;
let Loader      = undefined;

export default {
  name: 'Department',
  components: {   
    'ejs-toast': ToastComponent
  },
  data: function () {
    return {
      e_selectRow : null, e_selectData: null,
      e_phone_plat_from: null, e_cpu_abi: null, e_iso_value: null, e_is_auto_focus: null, e_max_sharpness: null,
      e_min_sharpness: null, e_support_sharpness: null, e_max_zoom: null, e_support_zoom: null, e_whitebalance_value: null,
      e_picture_size: null, e_preview_size: null, e_sense_descript: null, e_camera_descript: null, 
      e_buttons: [
        {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ],

      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      toolbar: null,
      datas: null,
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      imgPersonTemplate: function () { return { 
          template: Vue.component("imgPersonTemplate", {
          template:  `<div><div class="e-grid-empimg"><img :src="image" class='c-avatar-about-img' style='width:30px' /></div></div>`,
              data: function () { return { data: {}, usermale: 'usermale', userfemale: 'userfemale' }; },
          computed: {
              image: function() {
                  return this.data.img_url;
              }
          }
      })}},
    };
  },
  methods: {    
    toolbarClick: function (args) {       
      if (args.item.id == 'Edit') {
        this.recordDoubleClick();  
      }
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'相機資料.xlsx' });
      }   
    },   
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onRowDataBound(args) {
      if (args.data.state == 2) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },     
    checkHeader: function() {       
      this.toolbar = this.e_state == 0 ? 
      [
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search'] : 
      [
      
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },       
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search']
    },
    rowSelected: function(args) {    
      this.e_selectRow = args.row.getAttribute('aria-rowindex');        
      this.e_selectData = args.data;

      this.e_phone_plat_from = this.e_selectData.phone_plat_from; 
      this.e_cpu_abi = this.e_selectData.phone_plat_from;
      this.e_iso_value = this.e_selectData.iso_value;
      this.e_is_auto_focus = this.e_selectData.is_auto_focus_m;
      this.e_max_sharpness = this.e_selectData.max_sharpness;
      this.e_min_sharpness = this.e_selectData.min_sharpness;
      this.e_support_sharpness = this.e_selectData.support_sharpness;
      this.e_max_zoom = this.e_selectData.max_zoom; 
      this.e_support_zoom = this.e_selectData.support_zoom; 
      this.e_whitebalance_value  = this.e_selectData.whitebalance_value;
      this.e_picture_size = this.e_selectData.picture_size;
      this.e_preview_size = this.e_selectData.preview_size;
      this.e_sense_descript = this.e_selectData.sense_descript;
      this.e_camera_descript = this.e_selectData.camera_descript; 
      this.checkHeader();
    },  
         
    delCancelClick: function() {
        DialogObj.hide();
    },    
    editOkClick: function() {     

      this.showLoading();
      this.showMsg('修改成功!');     
      this.$refs.modalDialog.hide();    
      this.hideLoading();
      this.getAppManagerCameraData();      
    },  
    recordDoubleClick: function () {         
      this.$refs.modalDialog.show();   
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },
    getAppManagerCameraData: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'AppManager/Camera',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
          this.e_selectRow = null;
          this.checkHeader();
      })
      .catch((error) => { this.showError(error, true) }
      ) 
              
    },
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.checkHeader();
    this.getAppManagerCameraData();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}



</style>
<style lang="scss" src="../../scss/base.scss"></style>
